@use "sass:string";
@use "../../styles/breakpoint.module.scss" as *;

.card {
    grid-column: span 4;
    margin: 0;
    // needed to prevent VideoPlayerControls from stretching height too far
    align-self: start;

    &:has(a):not(:has(video)) {
        cursor: pointer;
    }

    @media ($below-mobile) {
        grid-column: 1 / -1;
        text-align: center;
    }
}

.media {
    img,
    video {
        width: 100%;
        height: auto;
        aspect-ratio: 4 / 3;
        object-fit: cover;
        display: block;
    }
}

.caption {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);
    padding-top: var(--spacer-8);
}

.title {
    font: var(--font-h-24-forma);
}

.subtitle {
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.captionLink {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);
}

:export {
    sizes: string.unquote("(min-width: #{$mobile}) 33vw, 100vw");
}
